import { h, Host } from '@stencil/core';
import { setNonceToElement } from '@pes-ui/utils';
export class BazaarVoiceRating {
  constructor() {
    this.productId = undefined;
    this.bazaarVoiceInfo = undefined;
    this.isError = false;
  }
  loadBVScript() {
    var _a;
    const script = document.createElement('script');
    script.src = (_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.scriptUrl;
    script.async = true;
    script.onerror = () => (this.isError = true);
    setNonceToElement(script);
    document.head.appendChild(script);
  }
  componentWillLoad() {
    var _a;
    if ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) {
      this.loadBVScript();
    }
  }
  render() {
    var _a;
    const configured = ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) && !this.isError;
    return (configured && (h(Host, { class: "bv__rating" }, h("div", { class: "product-description__special-review-section" }, h("div", { "data-bv-show": "rating_summary", "data-bv-product-id": this.productId }), h("input", { type: "hidden", id: "bazaarVoiceHidden", value: "true" })))));
  }
  static get is() { return "bazaar-voice-rating"; }
  static get originalStyleUrls() {
    return {
      "$": ["bazaar-voice-rating.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bazaar-voice-rating.css"]
    };
  }
  static get properties() {
    return {
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "bazaarVoiceInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBazaarVoiceInfo",
          "resolved": "{ enabled: boolean; scriptUrl: string; }",
          "references": {
            "TBazaarVoiceInfo": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isError": {}
    };
  }
}
